import en from "./locales/en.json";
import sv from "./locales/sv.json";
import et from "./locales/et.json";
var dictionaries = {
    en: en,
    sv: sv,
    et: et,
};
var currentLocale = "en";
var defaultLocale = "en";
export function initTranslations(config) {
    console.log("initTranslations:", config);
    currentLocale = config.locale;
    defaultLocale = config.defaultLocale;
}
export function setLocaleInternal(locale) {
    currentLocale = locale;
}
export function getLocale() {
    return currentLocale;
}
export function getSupportedLocales() {
    return Object.keys(dictionaries);
}
export function t(key, interpolations) {
    var value = getNestedValue(dictionaries[currentLocale], key);
    if (value === undefined && currentLocale !== defaultLocale) {
        value = getNestedValue(dictionaries[defaultLocale], key);
    }
    if (value === undefined) {
        console.warn("[Translation] Missing key: \"".concat(key, "\" for locale: \"").concat(currentLocale, "\""));
        return key;
    }
    if (interpolations) {
        return interpolate(value, interpolations);
    }
    return value;
}
function getNestedValue(obj, path) {
    var keys = path.split(".");
    var current = obj;
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (current === null || current === undefined || typeof current !== "object") {
            return undefined;
        }
        current = current[key];
    }
    return typeof current === "string" ? current : undefined;
}
function interpolate(template, values) {
    return template.replace(/\{\{(\w+)\}\}/g, function (match, key) {
        return key in values ? String(values[key]) : match;
    });
}
